// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"40a6fc23","952":"babe25b7"}[chunkId] + ".chunk.js";
};